"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../../..");
var useBoolean_1 = __importDefault(require("../../../../hooks/useBoolean"));
var LinkButton_1 = __importDefault(require("../../../Button/LinkButton"));
var Message_1 = require("../../../Message");
var Padder_1 = require("../../../Padder");
var Popup_1 = __importDefault(require("../../../Popup/Popup"));
var Field_1 = __importDefault(require("../../components/Field"));
var Label_1 = __importDefault(require("../../components/Label"));
var DruhOsobyForm_1 = __importDefault(require("./components/DruhOsobyForm"));
var DruhyOsobOption_1 = __importDefault(require("./components/DruhyOsobOption"));
var StyledDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 1em;\n"], ["\n  margin-bottom: 1em;\n"])));
var StyledDruhyOsobSelected = styled_components_1.default(DruhyOsobOption_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: #e5ebf0;\n  padding: 1rem;\n  position: relative;\n\n  & + & {\n    margin-top: 1em;\n  }\n"], ["\n  background-color: #e5ebf0;\n  padding: 1rem;\n  position: relative;\n\n  & + & {\n    margin-top: 1em;\n  }\n"])));
var DruhyOsobField = function (_a) {
    var name = _a.name, label = _a.label, druhyOsob = _a.druhyOsob, labels = _a.labels, filterResult = _a.filterResult, onSubmit = _a.onSubmit, onRemove = _a.onRemove, aktivniZanik = _a.aktivniZanik, upustitDolozeni = _a.upustitDolozeni, readOnly = _a.readOnly;
    var isOpen = useBoolean_1.default(false);
    var _b = formik_1.useField(name), field = _b[0], helpers = _b[2];
    var value = field.value || [];
    react_1.useEffect(function () {
        if (upustitDolozeni)
            upustitDolozeni(ramda_1.includes(__1.ZnalciDruhOsoby.znaleckaKancelar, ramda_1.pluck('druhOsoby', value)));
    }, [field.value]);
    var handleSubmit = function (v) {
        if (!ramda_1.includes(v.id, ramda_1.pluck('id', value))) {
            helpers.setValue(ramda_1.append(v, value));
        }
        if (onSubmit)
            onSubmit({ idZnalce: v.id, idSpecializace: v.specializaceIds });
        isOpen.setFalse();
    };
    var handleRemove = function (id) {
        helpers.setValue(ramda_1.filter(function (fieldItem) { return fieldItem.id !== id; }, value));
        if (onRemove)
            onRemove(id);
    };
    return (react_1.default.createElement("fieldset", { name: name, style: { marginTop: '1em' } },
        react_1.default.createElement(Field_1.default, null,
            react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
            react_1.default.createElement("div", null,
                !!value.length && (react_1.default.createElement(StyledDiv, null, value.map(function (fieldItem) { return (react_1.default.createElement(StyledDruhyOsobSelected, { key: fieldItem.id, znalec: fieldItem, onRemove: readOnly ? undefined : function () { return handleRemove(fieldItem.id); } })); }))),
                !readOnly && (react_1.default.createElement(LinkButton_1.default, { type: "button", className: "button", onClick: isOpen.toggle }, labels === null || labels === void 0 ? void 0 : labels.add)),
                react_1.default.createElement(Popup_1.default, { open: isOpen.value, onClose: isOpen.setFalse }, (aktivniZanik === null || aktivniZanik === void 0 ? void 0 : aktivniZanik.aktivniZanik) ? (react_1.default.createElement(Padder_1.Padder, null,
                    react_1.default.createElement(Message_1.Message, { type: "error" },
                        aktivniZanik.druhOsoby,
                        " se zanikl\u00FDm opr\u00E1vn\u011Bn\u00EDm nelze p\u0159id\u011Blit \u010Dlenstv\u00ED."))) : (react_1.default.createElement(DruhOsobyForm_1.default, { onSubmit: handleSubmit, labels: labels, druhyOsob: druhyOsob, filterResult: filterResult })))))));
};
DruhyOsobField.defaultProps = {
    filterResult: undefined,
    labels: {
        title: undefined,
        add: 'Přidat',
        submit: 'Přidat',
        search: undefined,
    },
    onSubmit: undefined,
    onRemove: undefined,
    aktivniZanik: false,
    upustitDolozeni: undefined,
    readOnly: false,
};
exports.default = DruhyOsobField;
var templateObject_1, templateObject_2;
